module.exports = __webpack_public_path__ + "img/service-2.9c2d3f69.jpg";